import React, { useState, useEffect } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import MaterialTypography from "../../components/MaterialTypography";
import { AppBar, Card, CardHeader, Stack, Tab, Tabs } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MaterialButton from "../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import BASEURL from "../Utils/Baseurl";
import axios from "axios";
import { useUserDetails } from "../../context/auth";
import MaterialBox from "../../components/MaterialBox";
import { alignItems } from "@mui/system";
import { getAllTypeTwoPayrolls } from "./components/Queries";
const Payroll = () => {
  const navigate = useNavigate();
  const {setexceldisplay,setexcelmonth,setexcelyear} = useUserDetails();
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [tabsOrientation, setTabsOrientation] = useState("horizontal"); //Used to store the orientation of the tabs
  const [tabValue, setTabValue] = useState("typeOne");
  const [employeeSalaryList, setEmployeeSalaryList] = useState([]);

  useEffect(() => {
    fetchPayrollsByType();
  }, [tabValue]);

  const SalaryStructureListTable = {
    columns: [
      {
        field: "year",
        headerName: "Year",
        flex: 1,

        sortable: true,
      },
      {
        field: "month",
        headerName: "Month",
        flex: 1,

        sortable: true,
      },
    
    ],
      rows: employeeSalaryList.map((manager,index) => ({
         id: index +1,
         year: manager.year,
         month: manager.month,
         monthvalue : manager.monthvalue
       
       })),
  };

  const handleNewSalaryStructure = () => {
      setexceldisplay(false);
      sessionStorage.setItem("payroll_mode", "add");
      sessionStorage.setItem("payroll_tab", tabValue);
      sessionStorage.removeItem("payroll_month");
      sessionStorage.removeItem("payroll_year");

      navigate(`/pay-roll/add-payroll?mode=add&tab=${tabValue}`, {
          state: {
              tab: tabValue,
          },
      });
  };
  const onEmployeeListClick = (e) => {
    const month = e?.row?.monthvalue;
    const year = e?.row?.year;
    setexceldisplay(true);
    setexcelmonth(month);
    setexcelyear(year);
    sessionStorage.setItem("payroll_mode", "view");
    sessionStorage.setItem("payroll_month", month);
    sessionStorage.setItem("payroll_year", year);
    sessionStorage.setItem("payroll_tab", tabValue);
    navigate(
      `/pay-roll/add-payroll?mode=view&month=${month}&year=${year}&tab=${tabValue}${e?.id ? `&id=${e?.id}` : ""}`,
      {
        state: {
          tab: tabValue,
        },
      }
    );
  };

  const getMonthName = (monthNumber) => {
    const months = [
        "January", "February", "March", "April", "May", "June", 
        "July", "August", "September", "October", "November", "December"
    ];
    
    return months[monthNumber - 1] || "Invalid month";
};


  const fetchPayrollsByType = async () => {
    const query = `
        query GetAllPayroll {
            allPayroll {
                user {
                    id
                    firstName
                    lastName
                    gender
                    fathersName
                    maritalStatus
                    aadharNumber
                    department
                    dateOfBirth
                    dateOfJoining
                    panNumber
                    uanNumber
                    bankDetails {
                        accountNumber
                        bankName
                        ifscNumber
                        branchName
                        cifNumber
                    }
                }
                updatedCtc
                month
                year
                gross
                totalDeductions
                totalBenefits
                netPay
                netpayWithOtammount
                overallSum
                oneDaySalary
                lossOfPayAmount
            }
        }
    `;

    try {
        setPageState({ ...pageState, loading: true });

        const response = await axios.post(
            BASEURL,
            {
                query: tabValue === "typeOne"
                    ? query
                    : getAllTypeTwoPayrolls,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        let payrollData = [];

        if (tabValue === "typeOne") {
            // Type 1 response
            payrollData = response.data?.data?.allPayroll || [];
        } else {
            // Type 2 response
            payrollData = response.data?.data?.allTypeTwoPayroll?.data || [];
        }

        // Normalize both responses
        const filterdata = payrollData.map((val) => ({
            year: val.year,
            month: getMonthName(val.month),
            monthvalue: val.month,
        }));

        // Remove duplicate month/year combinations
        const uniqueData = filterdata.filter(
            (value, index, self) =>
                index ===
                self.findIndex(
                    (obj) =>
                        obj.year === value.year &&
                        obj.monthvalue === value.monthvalue
                )
        );

        setEmployeeSalaryList(uniqueData);

        setPageState({
            ...pageState,
            loading: false,
            state: "success",
        });
    } catch (error) {
        console.error("ResponseError:", error);

        setPageState({
            ...pageState,
            loading: false,
            error: true,
            message: error.message,
        });
    }
};

  const handleSetTabValue = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          sx={{
              p: 2,
              pb: 0,
          }}
          title={
              <Stack spacing={2}>
                  {/* Header Row */}
                  <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      sx={{ width: "100%" }}
                  >
                      <Stack direction="column" spacing={0}>
                          <MaterialTypography variant="h5" fontWeight="medium">
                              Payroll List
                          </MaterialTypography>

                          <MaterialTypography variant="caption" fontWeight="medium">
                              List of all payrolls created according to Salary Types
                          </MaterialTypography>
                      </Stack>

                      <MaterialButton
                          variant="gradient"
                          color="dark"
                          size="small"
                          startIcon={<AddIcon />}
                          onClick={() => handleNewSalaryStructure()}
                      >
                          Run Payroll
                      </MaterialButton>
                  </Stack>

                  {/* Tabs - Second Row, Centered */}
                  <MaterialBox
                      sx={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                      }}
                  >
                      <AppBar
                          position="static"
                          sx={{
                              width: "50%",
                              boxShadow: "none",
                              backgroundColor: "transparent",
                          }}
                      >
                          <Tabs
                              orientation={tabsOrientation}
                              value={tabValue}
                              onChange={handleSetTabValue}
                              sx={{
                                  backgroundColor: "transparent",
                                  justifyContent: "center",
                              }}
                          >
                              <Tab
                                  label="Type 1"
                                  value="typeOne"
                              />

                              <Tab
                                  label="Type 2"
                                  value="typeTwo"
                              />
                          </Tabs>
                      </AppBar>
                  </MaterialBox>
              </Stack>
          }
        />
        <MaterialDataGrid
          // customHeight={550}
          rows={SalaryStructureListTable.rows}
          columns={SalaryStructureListTable.columns}
          checkboxSelection={false}
          isSelectable={false}
          onRowClick={onEmployeeListClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No payroll found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet add any payroll details. Click on the "Run
                  Payroll" button to start adding payroll.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default Payroll;
